import localStorage from "./local-storage";

export default {
    localStorage
};
